export default function GlobalStyles() {
  return (
    <style>{`
      @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=DM+Sans:wght@400;500;700&display=swap');

      @keyframes spin  { to { transform: rotate(360deg); } }
      @keyframes shake {
        0%, 100% { transform: translateX(0); }
        20%      { transform: translateX(-8px); }
        40%      { transform: translateX(8px); }
        60%      { transform: translateX(-6px); }
        80%      { transform: translateX(6px); }
      }

      :root {
        --font-display: 'Bebas Neue', sans-serif;
        --font-body:    'DM Sans', sans-serif;
        --bg:      #0a0a0a;
        --surface: #111;
        --border:  #1e1e1e;
        --accent:  #cc2200;
      }

      * { box-sizing: border-box; margin: 0; padding: 0; }
      body {
        font-family: var(--font-body);
        background: var(--bg);
        color: #ccc;
        min-height: 100vh;
        overflow-x: hidden;
      }

      .card {
        background: var(--surface);
        border: 1px solid var(--border);
        border-radius: 6px;
        padding: 20px;
      }

      .input {
        width: 100%;
        background: #0e0e0e;
        border: 1px solid #222;
        border-radius: 4px;
        color: #ccc;
        padding: 10px 14px;
        font-family: var(--font-body);
        font-size: 14px;
        outline: none;
        transition: border-color 0.15s;
      }
      .input:focus       { border-color: #cc2200; }
      .input::placeholder { color: #555; }
      .input::-webkit-calendar-picker-indicator { filter: invert(0.6); cursor: pointer; }

      .btn-primary {
        background: #cc2200;
        color: #fff;
        border: none;
        border-radius: 4px;
        padding: 10px 20px;
        font-family: var(--font-body);
        font-size: 13px;
        font-weight: 700;
        cursor: pointer;
        letter-spacing: 0.5px;
        transition: background 0.15s, transform 0.1s;
      }
      .btn-primary:hover    { background: #aa1a00; transform: translateY(-1px); }
      .btn-primary:active   { transform: translateY(0); }
      .btn-primary:disabled { opacity: 0.5; cursor: not-allowed; transform: none; }

      .btn-ghost {
        background: none;
        border: 1px solid #333;
        color: #999;
        border-radius: 4px;
        padding: 8px 14px;
        font-family: var(--font-body);
        font-size: 12px;
        cursor: pointer;
        transition: border-color 0.15s, color 0.15s;
      }
      .btn-ghost:hover { border-color: #555; color: #fff; }

      .btn-danger {
        background: none;
        border: 1px solid #2a1010;
        color: #cc2200;
        border-radius: 4px;
        padding: 8px 12px;
        font-family: var(--font-body);
        font-size: 12px;
        cursor: pointer;
        transition: background 0.15s;
      }
      .btn-danger:hover { background: #1a0000; }

      .form-row-2      { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
      .summary-grid    { display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; margin-bottom: 32px; }
      .event-card-inner   { display: flex; gap: 16px; align-items: flex-start; padding-left: 12px; }
      .event-card-actions { display: flex; gap: 8px; flex-shrink: 0; flex-wrap: wrap; justify-content: flex-end; }
      .section-header  { display: flex; justify-content: space-between; align-items: center; margin-bottom: 32px; }
      .event-title     { font-family: var(--font-display); font-size: 36px; font-weight: 900; margin: 0 0 10px; line-height: 1.1; color: #fff; }

      @media (max-width: 600px) {
        .event-card-inner   { flex-direction: column; }
        .event-card-actions { width: 100%; justify-content: flex-start; margin-top: 4px; }
        .form-row-2         { grid-template-columns: 1fr; }
        .summary-grid       { grid-template-columns: repeat(2, 1fr); }
      }
      @media (max-width: 480px) {
        .section-header { flex-wrap: wrap; gap: 10px; }
        .event-title    { font-size: 24px; }
      }
    `}</style>
  );
}
